import type { BriefDocument } from "@/lib/briefDocument";

export const emptyDoc: BriefDocument = { type: "doc", content: [{ type: "paragraph" }] };

export const storageKey = (workspaceId: string, briefId: string | null) =>
  `composer-draft-canvas:${workspaceId}:${briefId ?? "blank"}`;

export const isMeaningful = (doc: unknown): boolean => {
  try {
    const json = JSON.stringify(doc ?? {});
    return /"text"\s*:\s*"[^"]+"/.test(json);
  } catch {
    return false;
  }
};

/** First non-empty line of the doc, capped at 80 chars. */
export const docToTitle = (doc: unknown): string => {
  try {
    const root = doc as { content?: Array<{ content?: Array<{ text?: string }> }> };
    for (const block of root?.content ?? []) {
      const text = (block.content ?? []).map((c) => c.text ?? "").join("").trim();
      if (text) return text.slice(0, 80);
    }
  } catch {
    /* noop */
  }
  return "";
};

export const TITLE_DEBOUNCE_MS = 800;
